import type { BrandContext } from '@/lib/brand/types';

export type BrandLogMetadata = {
  brandKey: BrandContext['brandKey'];
  brandEnvironment: BrandContext['environment'];
  requestHost: BrandContext['requestHost'];
  requestOrigin: BrandContext['requestOrigin'];
  canonicalOrigin: BrandContext['canonicalOrigin'];
  isApprovedHost: BrandContext['isApprovedHost'];
  partnerKey?: BrandContext['partnerKey'];
  partnerId?: BrandContext['partnerId'];
};

export const getBrandLogMetadata = (
  brand: Pick<
    BrandContext,
    | 'brandKey'
    | 'environment'
    | 'requestHost'
    | 'requestOrigin'
    | 'canonicalOrigin'
    | 'isApprovedHost'
    | 'partnerKey'
    | 'partnerId'
  >
): BrandLogMetadata => ({
  brandKey: brand.brandKey,
  brandEnvironment: brand.environment,
  requestHost: brand.requestHost,
  requestOrigin: brand.requestOrigin,
  canonicalOrigin: brand.canonicalOrigin,
  isApprovedHost: brand.isApprovedHost,
  ...(brand.partnerKey ? { partnerKey: brand.partnerKey } : {}),
  ...(brand.partnerId ? { partnerId: brand.partnerId } : {}),
});
